export default __webpack_public_path__ + "static/centre-de-tri-etcheverry-mindurry-6cd8b7762e7c1c6419e5c4545eb6c086.jpg";